/*
 * @Author: YH000644 weirongwei@danghuan.com
 * @Date: 2024-12-03 12:07:17
 * @LastEditors: YH000644 weirongwei@danghuan.com
 * @LastEditTime: 2024-12-18 11:28:46
 * @FilePath: \eu-eswop-official-site\src\services\axios.js
 * @Description:
 */
import axios from 'axios'
import md5 from "js-md5"
import CryptoJS from 'crypto-js'
import { isDev } from '@/utils/config.js'

const baseURL = isDev ? '/api' : ''
import { customRequestHeader } from '@/locales';


let ts = Date.now()
// const secretKey = 'dh_vnu7ncxfz'
const channelId = '100000'
const nationCode = 'ES'

// 对象按照属性排序并拼接成字符串
const sortAndJoinObjectProperties = (params) => {
  let str = '';
  Object.keys(params).sort().forEach(key => {
    // console.log(params[key], '----params[key]-----')
    if (key === 'optionIds') {
      str += key + '=' + '[' + params[key].join(', ') + ']' + '&'
    } else if (params[key]) {
      str += key + '=' + params[key] + '&'
    }
  });
  return str.slice(0, -1);
}

const service = axios.create({
  baseURL,
  headers: {
    channelId,
    ts,
    nationCode,
    // sign: md5(channelId + secretKey + ts),
    'Accept-Language': customRequestHeader['Accept-Language'],
  },
  timeout: 20000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const dateTs = Date.now()
    const { data, headers, url } = config
    headers['ts'] = dateTs

    console.log(headers, '----headers---')
    if (url.includes('customer')) {
      let params = {}
      if (data) {
        Object.assign(params, data)
      } else {
        Object.assign(params, config.params)
      }
      params['nationCode'] = nationCode
      params['channelId'] = channelId
      params['ts'] =dateTs
      const secret = md5('europe@pc@h5@1#@7wllee57')

      const hmac = CryptoJS.HmacSHA256(sortAndJoinObjectProperties(params), secret)
      headers['sign'] = hmac.toString(CryptoJS.enc.Hex)
    }
    return config
  },
  error => {
    // 请求错误处理
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 响应后处理 && response.data.code === '0000'
    if (response.status === 200 ) {
      return Promise.resolve(response.data)
    } else {
      return Promise.reject(response.data)
    }
  },
  error => {
    // console.log('Response Error:', error)
    return Promise.reject(error)
  }
)

export default service
